import { defineComponent as z, ref as l, computed as m, watch as A, onMounted as H, openBlock as d, createElementBlock as r, normalizeClass as N, normalizeStyle as i, createCommentVNode as $, createElementVNode as q, renderSlot as w, Fragment as O, renderList as F } from "vue";
const E = /* @__PURE__ */ z({
  __name: "Marquee",
  props: {
    style: { default: () => () => ({}) },
    class: { default: "" },
    autoFill: { type: Boolean, default: !1 },
    play: { type: Boolean, default: !0 },
    pauseOnHover: { type: Boolean, default: !1 },
    pauseOnClick: { type: Boolean, default: !1 },
    direction: { default: "left" },
    speed: { default: 50 },
    delay: { default: 0 },
    loop: { default: 0 },
    gradient: { type: Boolean, default: !1 },
    gradientColor: { default: "white" },
    gradientWidth: { default: 200 }
  },
  emits: ["finish", "cycleComplete"],
  setup(e, { emit: o }) {
    const k = o, u = l(), c = l(), h = l(0), y = l(0), s = l(1), g = l(!1), v = l(), b = m(() => e.autoFill ? y.value * s.value / e.speed : y < h ? h.value / e.speed : y.value / e.speed), M = m(() => ({
      ...e.style,
      "--pause-on-hover": !e.play || e.pauseOnHover ? "paused" : "running",
      "--pause-on-click": !e.play || e.pauseOnHover && !e.pauseOnClick || e.pauseOnClick ? "paused" : "running",
      "--width": e.direction === "up" || e.direction === "down" ? "100vh" : "100%",
      "--transform": e.direction === "up" ? "rotate(-90deg)" : e.direction === "down" ? "rotate(90deg)" : "none"
    })), S = m(() => ({
      "--gradient-color": e.gradientColor,
      "--gradient-width": typeof e.gradientWidth == "number" ? `${e.gradientWidth}px` : e.gradientWidth
    })), B = m(() => ({
      "--play": e.play ? "running" : "paused",
      "--direction": e.direction === "left" ? "normal" : "reverse",
      "--duration": `${b.value}s`,
      "--delay": `${e.delay}s`,
      "--iteration-count": e.loop ? `${e.loop}` : "infinite",
      "--min-width": e.autoFill ? "auto" : "100%"
    })), C = m(() => ({
      "--transform": e.direction === "up" ? "rotate(90deg)" : e.direction === "down" ? "rotate(-90deg)" : "none"
    })), R = () => {
      if (c.value && u.value) {
        const t = u.value.getBoundingClientRect(), n = c.value.getBoundingClientRect();
        let a = t.width, f = n.width;
        (e.direction === "up" || e.direction === "down") && (a = t.height, f = n.height), e.autoFill && a && f ? s.value = f < a ? Math.ceil(a / f) : 1 : s.value = 1, h.value = a, y.value = f;
      }
    }, W = (t) => [
      ...Array(Number.isFinite(t) && t >= 0 ? t : 0)
    ];
    return A([() => e.autoFill, () => e.direction, g, u], () => {
      g.value && (R(), c.value && u.value && (v.value && v.value.disconnect(), v.value = new ResizeObserver(() => R()), v.value.observe(u.value), v.value.observe(c.value)));
    }), H(() => {
      g.value = !0;
    }), (t, n) => g.value ? (d(), r("div", {
      key: 0,
      ref_key: "containerRef",
      ref: u,
      class: N(["vfm-marquee-container", e.class]),
      style: i(M.value)
    }, [
      t.gradient ? (d(), r("div", {
        key: 0,
        style: i(S.value),
        class: "vfm-overlay"
      }, null, 4)) : $("", !0),
      q("div", {
        class: "vfm-marquee",
        style: i(B.value),
        onAnimationiteration: n[0] || (n[0] = (a) => k("cycleComplete")),
        onAnimationend: n[1] || (n[1] = (a) => k("finish"))
      }, [
        q("div", {
          style: i(C.value),
          class: "vfm-parent",
          ref_key: "marqueeRef",
          ref: c
        }, [
          w(t.$slots, "default")
        ], 4),
        (d(!0), r(O, null, F(W(s.value - 1), (a) => (d(), r("div", {
          style: i(C.value),
          class: "vfm-parent"
        }, [
          w(t.$slots, "default")
        ], 4))), 256))
      ], 36),
      q("div", {
        class: "vfm-marquee",
        style: i(B.value)
      }, [
        (d(!0), r(O, null, F(W(s.value), (a) => (d(), r("div", {
          style: i(C.value),
          class: "vfm-parent"
        }, [
          w(t.$slots, "default")
        ], 4))), 256))
      ], 4)
    ], 6)) : $("", !0);
  }
}), L = {
  install(e, o) {
    e.component((o == null ? void 0 : o.name) ?? "Marquee", E);
  }
};
export {
  E as Marquee,
  L as default
};
